//#region src/utils/imageGridLayout.ts
var e = 4;
function t(e) {
	let t = Math.min(Math.max(e, 0), 4), n = Math.max(e - t, 0);
	return {
		layout: t <= 1 ? "single" : t === 2 ? "two" : t === 3 ? "tallLeft" : "quad",
		visibleCount: t,
		extraCount: n
	};
}
//#endregion
export { e as MAX_IMAGE_TILES, t as getImageGridLayout };
